var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('div', { staticClass: "action-bar" }, [_c('el-button', { on: { "click": _vm.back } }, [_vm._v("返回")])], 1);
};
var staticRenderFns = [];

export { render, staticRenderFns };